var orientation = {
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom'
};
export default orientation;